import { GET_LEVELS } from '../Type';

export const getLevels = () => {
  return {
    type: GET_LEVELS,
    data: {}
  }
}